import React from 'react';
import { useField, Field } from 'formik';
import { Label } from 'reactstrap';
import './CheckBoxField.scss'

const CheckBoxField = (props) => {
  const [field, meta] = useField(props);

  return (
    <div className={`form-checkbox ${meta.touched && meta.error ? ' is-invalid' : ''}`}>
      <Label className='checkbox-container'>
        <span className="checkbox-text">{props.label}</span>
        <Field
          type="checkbox"
          className="checkbox-input"
          name={props.name}
        />
        <span className="checkbox-fill"></span>
      </Label>
      {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
    </div>
  )
}

export default CheckBoxField;
